import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.tasks,
    props.app.wallet,
    (tasks, wallet) => {
        tasks = tasks.filter(t => !t.claimed).sort((a,b) => {
            if(a.progress.percent < b.progress.percent) return 1;
            if(a.progress.percent > b.progress.percent) return -1;
            return 0;
        });

        return {
            task: tasks[0],
            count: tasks.length,
            wallet
        }
    }
)